import { Column, Stack, Text, Box } from 'braid-design-system';
import type React from 'react';

import LayoutBox from 'src/components/LayoutBox/LayoutBox';
import {
  sortDesktopFeatures,
  desktopFeatureLabels,
} from 'src/data/listing-products/desktop';
import { desktopFeatureLabelsFreemium } from 'src/data/listing-products/freemium/desktop';
import { isFreemiumExperiment } from 'src/data/listing-products/products';

const FeatureList = () => (
  <Column width="1/4">
    <Stack space="none">
      {sortDesktopFeatures(
        isFreemiumExperiment
          ? desktopFeatureLabelsFreemium
          : desktopFeatureLabels,
      ).map(([feature, label], i) => {
        const background = i % 2 === 0 ? 'neutralLight' : 'surface';
        return (
          <Box key={feature} data-testid="packages-desktop-feature-heading">
            <FeatureListItem background={background}>{label}</FeatureListItem>
          </Box>
        );
      })}
      {/* We require an empty item for table cell alignment */}
      <FeatureListItem background="surface">{null}</FeatureListItem>
    </Stack>
  </Column>
);

const FeatureListItem = ({
  background,
  children,
}: {
  background: 'neutralLight' | 'surface';
  children: React.ReactNode;
}) => (
  <Box background={background} padding="xsmall">
    <LayoutBox height={80}>
      <LayoutBox alignment="leftCentre">
        <Text size="standard" weight="regular">
          {children}
        </Text>
      </LayoutBox>
    </LayoutBox>
  </Box>
);

export default FeatureList;
